import { Form, Input } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import _ from 'lodash'
import { FC } from 'react'

interface NameProps {
    namePath: NamePath
}

const Name: FC<NameProps> = ({ namePath = [] }) => {
    const name = _.concat(namePath, 'name')

    return (
        <Form.Item name={name} label={'Наименование'}>
            <Input />
        </Form.Item>
    )
}

export default Name
